import SystemDataService from '../Services/SystemDataService';
import { ASSETS } from './assets-data'

// --- 1. THE CACHE STORAGE ---
// We store data here so we don't have to fetch it every time.
let ALL_LOCATIONS_CACHE = null;
const SLUG_CACHE = {};

const locationsFormatter = [
    {
        // --- BASE IDENTITY ---
        id: "cape-coral",
        isActive: true,
        slug: "garage-door-in-cape-coral-fl",
        name: "Cape Coral",
        image: "https://sawpy-assets.s3.us-east-2.amazonaws.com/RSAGarageDoors/images/cape-coral-image.png",

        // --- SEO ENGINE (Mapped to Layout component) ---
        seo: {
            title: "24/7 Garage Door Repair in Cape Coral, FL | RSA Garage Door",
            description: "Expert garage door repair, spring replacement, and new installations in Cape Coral. Serving SW Florida with 45-minute response times. Licensed & Insured.",
            keywords: "garage door repair cape coral, garage door installation fl, rsa garage door cape coral",
            image: "https://sawpy-assets.s3.us-east-2.amazonaws.com/RSAGarageDoors/images/cape-coral-image.png"
        },

        // --- AT A GLANCE (Mapped directly to MetricsSection) ---
        // Restructured to separate the Number (value) from the Label (suffix)
        atAGlance: [
            { label: "Arrival Time", value: "45", suffix: "Minutes", icon: "clock" },
            { label: "Price Range", value: "150", suffix: "$", icon: "tag" },
            { label: "Warranty", value: "10", suffix: "Years", icon: "shield" }
        ],

        // --- MAP & GEO ---
        geo: {
            lat: 26.5629,
            lng: -81.9495,
            zoom: 12,
            mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d114483.5658604752!2d-82.0284897!3d26.5628537!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88db420189a80001%3A0x296057863f821!2sCape%20Coral%2C%20FL!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
        },
        zones: [
            { id: 1, label: "Yacht Club Area", info: "Coastal Protection Priority", x: 48, y: 72 },
            { id: 2, label: "Pine Island Rd", info: "Commercial Service Hub", x: 55, y: 30 },
            { id: 3, label: "Santa Barbara", info: "Residential Specialist", x: 42, y: 45 }
        ],

        // --- HERO ---
        hero: {
            title: "Garage Door Services in Cape Coral, FL",
            subtitle: "Waterfront Home Protection & Repair",
            description: "Cape Coral's unique canal-side environment means high humidity and salt air. We specialize in corrosion-resistant hardware and hurricane-rated doors that meet local Lee County building codes.",
            imageDesktop: "https://sawpy-assets.s3.us-east-2.amazonaws.com/RSAGarageDoors/images/cape-coral-image.png",
            imageMobile: "https://sawpy-assets.s3.us-east-2.amazonaws.com/RSAGarageDoors/images/cape-coral-mobile.jpg",
            primaryBtnText: "Call Now",
            secondaryBtnText: "Book Online"
        },

        // --- INTRO ---
        intro: {
            title: "Why Cape Coral Residents Trust RSA",
            content: "With over 400 miles of canals, Cape Coral homes face more moisture than almost anywhere in Florida. This leads to rusted springs and track alignment issues. \n\nOur local technicians live right here in the Cape, allowing us to offer true 45-minute emergency response times when your door gets stuck."
        },

        // --- PROCESS ---
        process: {
            title: "Our 6-Step Precision Process",
            subtitle: "Our 6-Step Precision Process",
            types: [
                { title: "Point-of-Failure Audit", text: "We inspect 25 safety points to find the root cause, not just the symptom.", image: "/placeholder.svg" },
                { title: "Digital Estimate", text: "Transparency via text/email with photos of the wear and tear.", image: "/placeholder.svg" },
                { title: "Precision Repair", text: "Our trucks are 'mobile warehouses' stocked for same-day fixes.", image: "/placeholder.svg" }
            ]
        },

        // --- SERVICES LIST ---
        servicesList: [
            { title: "Residential Service", description: "Hurricane-rated garage doors for canal homes.", image: "https://s3.link/res-icon.png", slug: "residential" },
            { title: "Commercial Service", description: "Heavy-duty doors for Cape Coral businesses.", image: "https://s3.link/com-icon.png", slug: "commercial" }
        ],

        localInsights: {
            title: "Coastal Insights for SWFL",
            content: "The Florida Building Code (HVHZ) is strict in Cape Coral. We ensure every installation is 'Impact Rated' to protect your home's structural integrity during major storms."
        },

        caseStudy: {
            title: "Emergency Midnight Repair in SE Cape",
            content: "A homeowner's spring snapped at 11 PM on a Sunday. We arrived by 11:40 PM and had the door secured by midnight.",
            image: "/placeholder.svg"
        },

        pricing: {
            title: "Cape Coral Pricing Guide",
            items: [
                { service: "Spring Repair", range: "$180 - $350", note: "High-cycle galvanized steel" },
                { service: "New Impact Door", range: "$1,800 - $4,500", note: "Includes permits & haul-away" }
            ],
            guaranteeText: "All Cape Coral repairs include a 2-year labor warranty."
        },

        faqList: [
            { question: "Do you handle hurricane-rated doors?", answer: "Yes, we only install doors that meet or exceed local Lee County wind-load requirements." },
            { question: "What is your response time in the Cape?", answer: "Average arrival is 45 minutes for emergency calls." }
        ],

        schema: {
            "@context": "https://schema.org",
            "@type": "HomeAndConstructionBusiness",
            "name": "RSA Garage Door Cape Coral",
            "description": "Professional garage door repair in Cape Coral, FL.",
            "areaServed": { "@type": "City", "name": "Cape Coral" },
            "geo": { "@type": "GeoCoordinates", "latitude": "26.5629", "longitude": "-81.9495" }
        }
    },
];

export const getLocationsData = async () => {
    // 1. Check if we already have the data in memory
    if (ALL_LOCATIONS_CACHE) {
        return ALL_LOCATIONS_CACHE;
    }

    try {
        // --- API BYPASS: Using local formatter directly ---
        const apiData = await SystemDataService.getLocationsData();
        // const apiData = undefined;

        if (Array.isArray(apiData) && apiData.length > 0) {
            // 2. Save result to cache for next time
            ALL_LOCATIONS_CACHE = apiData;
            return apiData;
        } else {
            // console.warn('locations API returned empty, falling back to local formatter');
            // We cache the local data so the application treats it as the primary source
            ALL_LOCATIONS_CACHE = locationsFormatter;
            return locationsFormatter;
        }
    } catch (err) {
        console.error('Failed to load locations data from API, using local fallback', err);
        return locationsFormatter;
    }
};

export const getLocationBySlug = async (slug) => {
    // 1. Check if this specific slug is already cached
    if (SLUG_CACHE[slug]) {
        return SLUG_CACHE[slug];
    }

    // 2. Optimization: Check the local formatter first for immediate return
    const localResult = locationsFormatter.find(loc => loc.slug === slug);
    if (localResult) {
        SLUG_CACHE[slug] = localResult;
        return localResult;
    }

    try {
        // --- API BYPASS ---
        // const apiData = undefined;
        const apiData = await SystemDataService.getLocationsDataBySlug(slug);

        // Handle API returning an array vs object
        let result = null;
        if (Array.isArray(apiData) && apiData.length > 0) {
            result = apiData[0];
        } else if (apiData && typeof apiData === 'object') {
            result = apiData;
        }

        if (result) {
            // 3. Save to cache
            SLUG_CACHE[slug] = result;
            return result;
        }

        return null;

    } catch (err) {
        console.error('Failed to load location from API, using local fallback', err);
        return locationsFormatter.find(loc => loc.slug === slug);
    }
};

export const getAllLocations = () => locationsFormatter;